'use client'

import { IconChevronDown } from '@tabler/icons-react'
import styles from './ScrollHint.module.css'

interface ScrollHintProps {
  scrollY: number
  visible?: boolean
}

export default function ScrollHint({ scrollY, visible = true }: ScrollHintProps) {
  // Fade out as user scrolls
  const opacity = Math.max(0, 1 - (scrollY / 200))
  
  if (!visible || opacity === 0) return null

  return (
    <div 
      className={styles.scrollHint}
      style={{ opacity }}
      aria-label="Scroll down to see more"
      role="button"
      tabIndex={0}
      onClick={() => {
        window.scrollTo({
          top: window.innerHeight,
          behavior: 'smooth'
        })
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          window.scrollTo({
            top: window.innerHeight,
            behavior: 'smooth'
          })
        }
      }}
    >
      <div className={styles.circle}>
        <IconChevronDown size={20} className={styles.arrow} />
      </div>
    </div>
  )
}